import "./index.css";
import FlowNumbersBox from "../FlowNumbersBox";
import SystemBoundary from "../HeaderBox/SystemBoundary";
const SubHeaderBox = ({
  subTitle,
  scope,
  subDescription,
  isNormal,
  number,
  systemBoundaryProps,
  showSystemBoundary,
  icon,
  customBGColor,
  customTextColor,
  isCategory,
  handleShowCategory,
  showCategory,
}) => {
  return (
    <div
      className="subheader-box"
      style={{
        display: "flex",
        ...(!showSystemBoundary && { alignItems: "center" }),
        ...(customBGColor
          ? { backgroundColor: customBGColor }
          : { backgroundColor: "rgba(25, 54, 102, 0.8)" }),
      }}
    >
      {icon && (
        <div style={{ marginRight: "20px" }}>
          <img src={icon} alt="Subgroup Icon" width={60} height={60} />
        </div>
      )}
      <div style={{ width: "100%" }}>
        <h5
          style={{
            margin: 0,
            marginBottom: "5px",
            fontWeight: "bold",
            color: customTextColor ? customTextColor : "white",
          }}
        >
          {subTitle}
        </h5>
        {scope && (
          <p
            style={{
              color: "#d7e1d9",
              padding: 0,
            }}
          >
            {scope}
          </p>
        )}
        <p
          style={{
            padding: 0,
            marginBottom: 0,
            color: customTextColor ? customTextColor : "white",
          }}
        >
          {subDescription}
        </p>
        {isCategory && (
          <div
            className="create-category-bg"
            style={{ maxWidth: "70%", marginTop: "12px" }}
          >
            <div className="create-category-left">
              <h5 style={{ color: "#203669", fontSize: "14px" }}>
                Create Category
              </h5>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <h5
                style={{
                  color: "white",
                  marginRight: "5px",
                  fontSize: "14px",
                }}
              >
                Add
              </h5>
              <div
                className="create-category-switch"
                onClick={handleShowCategory}
                style={{
                  maxWidth: "fit-content",
                  display: "flex",
                  height: "100%",
                }}
              >
                <div
                  className={
                    showCategory ? "create-category-chosen-switch" : ""
                  }
                  style={{ width: "50px", height: "100%" }}
                ></div>
                <div
                  className={
                    !showCategory ? "create-category-chosen-switch" : ""
                  }
                  style={{ width: "50px", height: "100%" }}
                ></div>
              </div>
              <h5
                style={{ color: "white", marginLeft: "5px", fontSize: "14px" }}
              >
                Off
              </h5>
            </div>
          </div>
        )}
        {showSystemBoundary && <SystemBoundary {...systemBoundaryProps} />}
      </div>

      {number && (
        <div
          style={{
            position: "absolute",
            bottom: "3px",
            right: "30px",
            paddingBottom: "5px",
          }}
        >
          <FlowNumbersBox isNormal={isNormal} number={number} />
        </div>
      )}
    </div>
  );
};

export default SubHeaderBox;
